import React, { Component } from "react";
import "./about.scss";

import {
  Conatiner,
  Conatiner_title_01,
  Conatiner_1,
  Pic,
  Pic_02,
  Conatiner_1_setion,
  Conatiner_text_01,
  Conatiner_text_02,
  Conatiner_pre_footer,
  Conatiner_pre_footer_blocks,
  Conatiner_pre_footer_title_01,
  Block_links,
  Conatiner_footer,
  Conatiner_footer_list,
  Conatiner_footer_list_container,
  Bottom_label,
  Conatiner_Title,
} from "./style";

export class Brand_Distribution extends Component {
  render() {
    return (
      <Conatiner>
        <Conatiner_Title>Brand Licensing & Distribution</Conatiner_Title>
        <Conatiner_1>
          <Conatiner_1_setion>
            <Conatiner_title_01>International Wholesale</Conatiner_title_01>
            <br></br>
            <Conatiner_text_01>
              IDEAL started showroom business in New york form 2008,<br></br>and
              as of jan 2021, we have supported over 70 brands to make<br></br>{" "}
              inroads into global markets and have susscessfully put it through
            </Conatiner_text_01>
          </Conatiner_1_setion>
          <Pic src="Images/About_pics/Rectangle 571.jpg" />
        </Conatiner_1>

        <Pic_02 src="Images/About_pics/Rectangle 571.jpg" />
        <Conatiner_text_02>
          IDEAL started showroom business in New york form 2008,<br></br>and as
          of jan 2021, we have supported over 70 brands to make<br></br> inroads
          into global markets and have susscessfully put it through
        </Conatiner_text_02>

        <Conatiner_pre_footer>
          <Conatiner_pre_footer_title_01>
            International Wholesale
          </Conatiner_pre_footer_title_01>
          <Conatiner_pre_footer_blocks>
            <Block_links href="#">About us</Block_links>
            <Block_links href="#">International Wholesale</Block_links>
            <Block_links href="#">Marketing/PR/Event</Block_links>
            <Block_links href="#">Licensing & Distribution</Block_links>
            <Block_links href="#">Fullfillment Services</Block_links>
          </Conatiner_pre_footer_blocks>
        </Conatiner_pre_footer>
      </Conatiner>
    );
  }
}

export default Brand_Distribution;
